import { Component, ChangeDetectionStrategy } from '@angular/core'

@Component({
  selector: 'app-root',
  templateUrl: './root.component.html',
  styleUrl: './root.component.sass',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class RootComponent {
}
